/* eslint-disable */
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, InputAdornment, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { ToastContainer, toast } from 'react-toastify';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import token from '../../../../helpers/TokenDecoder';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import userServices from '../../../../commonServices/UserServices';
import services from '../Services';;
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';

export default function RoleAddEdit(props) {
    const screenCode = 'USERROLE';
    const navigate = useNavigate();

    const [roleLevels, setRoleLevels] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityID: "0",
        roleLevelID: "",
        roleName: "",
        isActive: true
    });
    const [tokenData, setTokenData] = useState({
        group: 0,
        factory: 0,
        userID: 0
    });

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: false,
        submitButtonName: "Save",
        pageName: "Add User Role"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const UserRoleSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required'),
        operationEntityID: Yup.number().min(1, 'Please select a Operation Entity').required('Operation Entity Required'),
        roleLevelID: Yup.number().min(1, 'Please select a role level').required('Role level Required'),
        roleName: Yup.string().required('Role name required')
    });

    const { roleID } = useParams();
    let decrypted = 0;


    useEffect(() => {
        GetRoleLevles();
        decrypted = AESDecryptionParam(roleID);
        if (decrypted != 0) {
            setPageProps({
                ...pageProps,
                isEdit: true,
                submitButtonName: "Update",
                editingID: parseInt(decrypted),
                pageName: "Edit User Role"
            })
            trackPromise(setForEdit(decrypted));
        }
        var tok = token.getGroupFactoryToken();
        var userID = token.getUserIDFromToken();
        if (tok != null) {
            setTokenData({
                group: tok.group,
                factory: tok.factory,
                userID: parseInt(userID)
            });
        }
    }, []);

    async function setForEdit(id) {
        let result = await services.getRoleDetailsByID(id);
        if (result != null) {
            setValues({
                groupID: result.groupID,
                operationEntityID: result.factoryID,
                roleName: result.roleName,
                roleLevelID: result.roleLevelID,
                isActive: result.isActive
            })
        }
    }

    async function GetRoleLevles() {
        var res = await userServices.getRoleLevels()

        if (res != null) {
            setRoleLevels(res);
        }
    }

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            roleLevelID: formData.roleLevelID,
            roleName: formData.roleName,
            isActive: formData.isActive
        },

        validationSchema: UserRoleSearchSchema,

        onSubmit: (values) => {
            if (pageProps.isEdit != 0) {
                trackPromise(UpdateUser(values, tokenData.userID, pageProps.editingID))
            } else {
                trackPromise(SaveRole(values, tokenData.userID));
            }

        },
    });

    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        GetOperationEntityByGroupID();
    }, [formik.values.groupID]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWUSERROLE');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });
        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        GetAllGroups();
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        var res = await services.GetFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }

    async function SaveRole(values, user) {
        var res = await services.SaveUserRole(values, user);
        if (res.statusCode === "Success") {
            toast.success("Role Saved Succesfully");
            setTimeout(() => {
                navigate('/dashboard/userRole');
            }, 3000);

        } else {
            toast.error(res.message);

        }

    }
    async function UpdateUser(values, user, roleID) {
        var res = await services.EditUserRole(values, user, roleID);
        if (res.statusCode === "Success") {
            toast.success("Role Updated Succesfully");
            setTimeout(() => {
                navigate('/dashboard/userRole');
            }, 3000);
        } else {
            toast.error(res.message);
        }
    }

    const { errors, touched, setValues, handleSubmit, isSubmitting, getFieldProps, values } = formik;


    return (
        <>
            <LoadingComponent />
            <Page title="User Role |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/userRole"}
                        btname="Back"
                        pageName={pageProps.pageName}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Operation Entity *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Operation Entity</MenuItem>
                                        {operationEntityList.map((option) => (
                                            <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Role Level *"
                                        value={formik.values.roleLevelID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('roleLevelID')}
                                        error={Boolean(touched.roleLevelID && errors.roleLevelID)}
                                        helperText={touched.roleLevelID && errors.roleLevelID}
                                    >
                                        <MenuItem key={0} value={0}> Select Role</MenuItem>
                                        {roleLevels.map((option) => (
                                            <MenuItem key={option.roleLevelID} value={option.roleLevelID}>
                                                {option.roleLevelName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Role Name *"
                                        value={formik.values.roleName}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('roleName')}
                                        error={Boolean(touched.roleName && errors.roleName)}
                                        helperText={touched.roleName && errors.roleName}
                                    />
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                value={formik.values.isActive}
                                                checked={formik.values.isActive}
                                                {...getFieldProps('isActive')}
                                                onClick={formik.handleChange}
                                                color='error'
                                                name="isActive"
                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                            />}
                                        label="Is Active"
                                    />
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        color='error'
                                        onClick={() => formik.resetForm()}
                                    > Clear</Button>

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color='secondary'
                                    >{pageProps.submitButtonName}</Button>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                </Container>
            </Page>
        </>
    );
}